import { SearchBar, type SearchBarWhereProps, type WhenSelection } from "@ui/components/SearchBar";
import type { ReactNode } from "react";

export interface IndexViewProps {
  /** Wired props for the Where section (location search field + current selection). */
  whereProps: SearchBarWhereProps;
  /** Current When (travel window) selection. */
  whenValue: WhenSelection;
  /** Called when the When selection changes. */
  onWhenChange: (value: WhenSelection) => void;
  /** Sort pill, wired to the shared destinations sort context. */
  sortControl: ReactNode;
  /** Filters panel body (temperature / cost / köppen / …), rendered inside `SearchBar.Filters`. */
  filters: ReactNode;
  /** Sticky Filters-modal footer; receives a `close` callback. */
  renderFiltersFooter: (close: () => void) => ReactNode;
}

/**
 * Presentational destinations-index search bar. It lives in the TopBar's `bottomContent`
 * slot so it persists across scrolls and the map's full-viewport calc adapts via
 * `--frame-topbar-h`. Hidden at narrow viewports — discovery chrome is desktop-only on
 * `/destinations` today. All search wiring lives in the container (`index.tsx`); this
 * renders markup only.
 */
export function IndexView({
  whereProps,
  whenValue,
  onWhenChange,
  sortControl,
  filters,
  renderFiltersFooter,
}: IndexViewProps) {
  return (
    <div className="hidden border-neutral-100 border-b bg-white px-5 pb-6 lg:block md:px-8">
      <SearchBar>
        <SearchBar.Sections>
          <SearchBar.Where {...whereProps} />
          <SearchBar.When onChange={onWhenChange} value={whenValue} />
        </SearchBar.Sections>
        {sortControl}
        <SearchBar.Filters footer={renderFiltersFooter} size="lg">
          {filters}
        </SearchBar.Filters>
      </SearchBar>
    </div>
  );
}
